import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index';

function ordinalNumber(dirtyNumber, dirtyOptions) {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'ला';
      case 2:
        return number + 'रा';
      case 3:
        return number + 'रा';
    }
  }
  return number + 'था';
}

const eraValues = {
  narrow: ['बी', 'ए'],
  abbreviated: ['बीसी', 'एडी'],
  wide: ['ईसा पूर्व', 'ईसा के बाद'],
};

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['प्रश्न 1', 'प्रश्न 2', 'प्रश्न 3', 'प्रश्न 4'],
  wide: ['1 ली तिमाही', '2 सरी तिमाही', '3 सरी तिमाही', '4 थी तिमाही'],
};

const monthValues = {
  narrow: ['जे', 'एफ', 'एम', 'ए', 'एम', 'आई', 'जे', 'ए', 'एस', 'ओ', 'एन', 'डी'],
  abbreviated: [
    'जनवरी',
    'फरवरी',
    'मार्च',
    'अप्रैल',
    'मई',
    'जून',
    'जुलाई',
    'अगस्त',
    'सितंबर',
    'अक्टूबर',
    'नवंबर',
    'दिसंबर',
  ],
  wide: [
    'जनवरी',
    'फरवरी',
    'मार्च',
    'अप्रैल',
    'मई',
    'जून',
    'जुलाई',
    'अगस्त',
    'सितंबर',
    'अक्टूबर',
    'नवंबर',
    'दिसंबर',
  ],
};

const dayValues = {
  narrow: ['एस', 'एम', 'टी', 'डब्ल्यू', 'टी', 'एफ', 'एस'],
  short: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
  abbreviated: ['रवि', 'सोम', 'मंगल', 'बुध', 'वृहस्पति', 'शुक्र', 'शनि'],
  wide: [
    'रविवार',
    'सोमवार',
    'मंगलवार',
    'बुधवार',
    'वृहस्पतिवार',
    'शुक्रवार',
    'शनिवार',
  ],
};

const dayPeriodValues = {
  narrow: {
    am: 'ए',
    pm: 'पी',
    midnight: 'एमआइ',
    noon: 'एन',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात',
  },
  abbreviated: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'मध्याह्न',
    morning: 'सुबह',
    afternoon: 'दोपहर के बाद',
    evening: 'शाम',
    night: 'रात्रि',
  },
  wide: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'मध्याह्न',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात',
  },
};

const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
  }),
};

export default localize;
